import { DashboardShell } from "@/components/dashboard-shell";
import { ActivityFeed } from "@/components/activity/activity-feed";
import { createFileRoute } from "@tanstack/react-router";
import {
  RouteLoading,
  FeedLoadingSkeleton,
} from "@/components/route-loading";

export const Route = createFileRoute("/activity")({
  component: ActivityPage,
  head: () => ({ meta: [{ title: "Activity" }] }),
  pendingComponent: ActivityPending,
});

function ActivityPage() {
  return (
    <DashboardShell>
      <ActivityFeed />
    </DashboardShell>
  );
}

// Shown while this route's chunk (and the ReUI components in it)
// downloads. Was src/app/activity/loading.tsx.
function ActivityPending() {
  return (
    <RouteLoading>
      <FeedLoadingSkeleton />
    </RouteLoading>
  );
}
